import React from 'react';
import IllustrationSection from './IllustrationSection';
import HeaderSection from './HeaderSection';

const Index = () => {
  return (
    <div className="flex flex-col sm:flex-row w-full h-auto p-4 sm:p-8 gap-8 " data-aos="fade-up">
      <div className="flex-grow h-auto w-auto lg:w-[50%]">
        <HeaderSection />
      </div>
      <div className="flex-grow h-auto ">
        <IllustrationSection />
      </div>
    </div>
  );
};

export default Index;
